// frontend/src/components/GuestLimitModal/GuestLimitModal.jsx

import React from 'react';
import { useTranslation } from 'react-i18next'; // 1. Import hook
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Box } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const GuestLimitModal = ({ isOpen, onClose, onLogout }) => {
  const { t } = useTranslation(); // 2. Initialize hook

  const handleLogoutAndRegister = () => {
    onLogout();
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="guest-limit-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'var(--primary-color)',
          maxWidth: '450px',
        }
      }}
    >
      <DialogTitle id="guest-limit-dialog-title" sx={{ textAlign: 'center', pb: 1 }}>
        <LockOpenIcon sx={{ color: 'var(--primary-color)', fontSize: '2.5rem', mb: 1 }} />
        {/* 3. Replace text with t() function */}
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
          {t('guestLimitModal.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', px: 2 }}>
          {t('guestLimitModal.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', p: 2, pt: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
            <Button 
                onClick={handleLogoutAndRegister} 
                variant="contained" 
                sx={{ 
                    mb: 1, 
                    fontWeight: 'bold', 
                    color: '#FFFFFF',
                    backgroundColor: 'var(--secondary-color)', 
                    '&:hover': { backgroundColor: 'var(--primary-color)' } 
                }}
            >
                {t('guestLimitModal.registerButton')}
            </Button>
            <Button 
                onClick={onClose} 
                variant="outlined"
                sx={{ 
                    mb: 1, 
                    fontWeight: 'bold', 
                    color: 'var(--primary-color)',
                    backgroundColor: 'var(--text-primary-color-white)', 
                    borderColor: 'var(--primary-color)',
                    '&:hover': { backgroundColor: 'var(--tertiary-color)' } 
                }}
            >
                {t('guestLimitModal.cancelButton')}
            </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default GuestLimitModal;